export const REQUEST_HEADER_KEY = 'x-selected-company';
